import '/assets/styles/sections/spotlight.scss';
import Icon from "@wearetla/tla-essentials-tools/partials/icon"
import Img from '@wearetla/tla-essentials-tools/partials/img';
import classNames from "classnames"
import { useInView } from 'react-intersection-observer'

const Spotlight = ({ imagePosition = 'right', icon, title, subtitle, features, darkBg, mockup, id }) => {
  const [imageWrapRef, inView] = useInView({
    threshold: 0.5,
		triggerOnce: true,
		disabled: false,
  })
  return (
    <section
      id={id}
      className={classNames('section spotlight', `imgpos-${imagePosition}`, { 'dark-bg': darkBg})}>
      <div className="spotlight-wrap wrapper">
        <div className="spotlight-textwrap">
          {icon &&
            <Icon name={icon} className="spotlight-icon" />
          }
          {title &&
            <h2 className="spotlight-title">{title}</h2>
          }
          {subtitle &&
            <div className="spotlight-subtitle">
              {subtitle}
            </div>
          }
          {features?.length &&
            <ul className="spotlight-features">
              {features.map((feature, nth) => (
                <li className="features-feature" key={nth}>
                  {feature.icon &&
                    <Icon
                      className="feature-icon"
                      name={feature.icon} />
                  }

                  <span className="feature-text">
                    {feature.text}
                  </span>
                </li>
              ))}
            </ul>
          }
        </div>
        <div
          className="spotlight-imagewrap"
          ref={imageWrapRef}>
          <Img
            className={classNames('imagewrap-mockup', { 'show': inView })}
            src={mockup} />
        </div>
      </div>
    </section>
  )
}

export default Spotlight;